<template>
  <div
    v-if="model"
    class="organizer-settings-form">
    <sForm
      id="settings-form"
      ref="form"
      label-position="top"
      :model="model"
      :rules="rules">
      <sFormItem
        :label="$t('Common.Organization')"
        prop="organizationView.organizationId">
        <sInput
          v-if="loading || isEdit"
          readonly
          :value="value.organizationView.organizationTitle"/>
        <OrganizersSelect
          v-else-if="model.organizationView"
          ref="organizers"
          v-model="model.organizationView.organizationId"
          class="width-100"
          :disabled="isEdit"
          @on-change="handleOrganization"/>
      </sFormItem>
      <sFormItem
        :label="$t('OrgSettings.setting')"
        prop="settingId">
        <div
          v-if="selectedSetting"
          slot="label-after"
          class="pl-3 opacity-5 font-size-10">
          {{ selectedSetting.settingType }}
        </div>
        <sInput
          v-if="loading || isEdit"
          readonly
          :value="value.settingInfo.settingTitle"/>
        <SettingsSelect
          v-else
          v-model="model.settingId"
          class="width-100"
          :disabled="isEdit"
          @on-change="handleSetting"/>
      </sFormItem>
      <SettingItem
        v-if="selectedSetting && model.organizationView"
        v-model="model.settingValue"
        :form="formData"
        :loading="loading || loadingDetailView"
        :organization-id="model.organizationView.organizationId"
        prop="settingValue"
        :setting="selectedSetting"/>
      <div
        v-if="(loading && model.userCount) || showAddPersonalSettings"
        class="organizer-settings-form-personal">
        <p class="organizer-settings-form-personal-title">
          {{ $t('OrgSettings.personalSettings') }}
        </p>
        <sInput
          v-if="loading"
          readonly/>
        <sSelect
          v-else
          class="width-100"
          filterable
          multiple
          :placeholder="$t('OrgSettings.selectUser')"
          :value="selectedUser"
          value-key="userId"
          @addedItem="handleUser"
          @removedItem="removedUser">
          <sOption
            v-for="user in users"
            :key="user.userId"
            :label="`${user.userName} (${user.userEmail})`"
            :value="user"/>
        </sSelect>
      </div>
      <sAlert
        v-if="errorMessage"
        class="mb-4"
        show-icon
        small
        type="error">
        {{ errorMessage }}
      </sAlert>
      <template v-if="loading">
        <div
          v-for="i in model.userCount"
          :key="`user-loading-${i}`"
          class="user-settings loading"/>
      </template>
      <template
        v-else-if="selectedSetting && !selectedSetting.notAvailableSetUserValue && model.users && model.users.length && model.settingId">
        <div
          v-for="({ userInfo }, index) in model.users"
          :key="index"
          class="user-settings-item"
          :class="{'mb-0': index === model.users.length-1}">
          <div class="user-settings-item-user">
            <div
              v-if="index === 0"
              class="user-settings-item-user__label">
              {{ $t('Common.User') }}
            </div>
            <div class="user-settings-item-user__login">
              {{ userInfo.userName }}
            </div>
            <div class="user-settings-item-user__email">
              {{ `(${userInfo.userEmail})` }}
            </div>
          </div>
          <SettingItem
            v-if="model.users && model.users[index]"
            v-model="model.users[index].settingValue"
            class="user-settings-item-setting"
            :form="formData"
            :hide-label="index !== 0"
            :loading="loading || loadingDetailView"
            :prop="`users.${index}.settingValue`"
            :setting="selectedSetting"
            :show-message="false">
            <sButton
              color="var(--color-error)"
              icon="delete"
              small
              type="border"
              @click="deleteUserSetting(userInfo.userId)"/>
          </SettingItem>
        </div>
      </template>
    </sForm>
  </div>
</template>
<script>
import SettingItem from 'components/organizer-settings/SettingItem.vue'
import SettingsSelect from 'components/organizer-settings/SettingsSelect.vue'
import OrganizersSelect from 'components/organizer-settings/OrganizersSelect.vue'

import organizerSettings from 'mixins/organizerSettings'
import formio from 'mixins/formio'

import OrganizerSettingApi from '@/api/organizerSettingApi'
const organizer_setting_api = new OrganizerSettingApi()

export default {
  name: 'organizerSettingForm',
  data() {
    return {
      formCode: null,
      organizationId: null,
      formData: null,
      organizers: [],
      users: [],
      //selectedUser: null,
      loadingOrganizers: false,
      loadingDetailView: true,
      selectedSetting: null,
    }
  },
  mixins: [organizerSettings, formio],
  methods: {
    async getForm() {
      this.formData = await this.$_getForm({
        formCode: this.formCode,
        params: [
          {key: 'organizationId', value: this.organizationId?.toString()},
          {key: 'settingId', value: this.value.settingInfo?.settingId?.toString()}
        ]
      })
    },
    getOrganizerUsers() {
      if (!this.selectedSetting?.notAvailableSetUserValue && this.value.organizationView.organizationId) {
        organizer_setting_api.getOrganizationUsers(this.value.organizationView.organizationId)
          .then((res) => {
            this.users = (res || []).sort((a, b) => a.userName?.localeCompare(b.userName))
          })
      }
    },
    handleOrganization(organizer) {
      this.model.organizationView = organizer
      this.model.users = []
      this.getOrganizerUsers()
      this.handleSetting()
    },
    handleSetting() {
      if (this.model.settingId &&
      (!this.model.settingValue || this.model.settingValue.settingId !== this.model.settingId)) {
        this.loadingDetailView = true
        organizer_setting_api.getSettingDetailView(this.model.settingId)
          .then((res) => {
            if (res) {
              const selectedSetting = res || {}
              this.selectedSetting = selectedSetting
              if (!this.value?.settingId) {
                this.model.settingValue = this.$_defaultSettingValue(selectedSetting)
              }
              if (res?.notAvailableSetUserValue) {
                this.model.users = []
              } else if (!res?.notAvailableSetUserValue && !this.value?.settingId) {
                this.model.users?.forEach((v) => { v.settingValue = this.$_defaultSettingValue(selectedSetting) })
              }
            } else {
              this.$notice.error({
                title: this.$t('Common.ErrorTitle'),
                message: this.$t('OrgSettings.Errors.GetSettingDetails') + this.$t('Errors.STHWrong'),
              })
            }
          })
          .finally(() => {
            this.loadingDetailView = false
          })
      } else {
        this.selectedSetting = null
      }
    },
    removedUser(user) {
      this.model.users = this.model.users.filter(i => i.userInfo.userId !== user[0].userId)
    },
    handleUser(user) {
      this.model.users.push({
        settingValue: this.$_defaultSettingValue(this.selectedSetting),
        userInfo: user[0],
      })
      //this.selectedUser = null
    },
    deleteUserSetting(id) {
      this.model.users = this.model.users.filter((v) => v.userInfo.userId !== id)
    },
  },
  computed: {
    errorMessage() {
      if (this.users?.length && this.value.users?.length) {
        const notContainKey = this.value.users
          .filter(i => !this.users.map(u => u.userId)
            .includes(i.userInfo.userId))
        return notContainKey?.length ? `${this.$t('Common.UnknownUsers')} ("${notContainKey.map(i => i.userInfo.userName).join(', ')}")` : ''
      }
      return null
    },
    selectedUser: {
      get() {
        return this.model?.users?.map(i => i.userInfo)
      }
    },
    model: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      },
    },
    rules() {
      const that = this
      const emailRegex = /(^([a-zA-Z0-9]+([a-zA-Z0-9_\-."]+))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/
      const correctEmail = (item) => {
        const result = item.trim() && emailRegex.test(item.trim())
        return result
      }
      const email = () => {
        const value = that.model.settingValue
        return value?.length ? value.split(',').every(correctEmail) : false
      }

      let result = {
        organizationId: [
          {
            trigger: 'change',
            required: false
          }
        ],
        settingId: [
          {
            trigger: 'change',
            required: true
          }
        ],
        settingValue: [
          {
            trigger: 'change',
            required: true,
            message: that.$t('Validate.Required')
          }
        ],
      }
      this.value.users?.forEach((user, userIndex) => {
        const userRules = [
          {
            trigger: 'change',
            required: true,
            message: that.$t('Validate.Required')
          }
        ]
        if (that.selectedSetting?.settingType === that.settingTypes.emailList) {
          userRules.push({
            validator(rule, value, callback) {
              if (!email()) {
                callback(new Error(that.$t('Tenders.MailRules', {mail: ''})))
                return
              }
              callback()
            }
          })
        }
        result['users.' + userIndex + '.settingValue'] = userRules
      })

      if (that.selectedSetting?.settingType === that.settingTypes.emailList) {
        result.settingValue.push({
          validator(rule, value, callback) {
            if (!email()) {
              callback(new Error(that.$t('Tenders.MailRules', {mail: ''})))
              return
            }
            callback()
          }
        })
      }

      return result
    },
    showAddPersonalSettings() {
      return this.model?.organizationView?.organizationId
          && !this.selectedSetting?.notAvailableSetUserValue
    },
  },
  watch: {
    model: {
      immediate: true,
      deep: true,
      handler(newValue, oldValue) {
        if (this.isEdit) {
          if (!this.users?.length || !oldValue || newValue.organizationView.organizationId !== oldValue?.organizationView?.organizationId) {
            this.getOrganizerUsers()
          }
          this.selectedSetting = newValue.settingInfo
        }

        const changeFormCode = newValue.settingInfo.formCode !== this.formCode
        const changeOrganizationId = this.organizationId !== newValue.organizationView?.organizationId
        if (newValue.settingInfo.formCode && (changeFormCode || changeOrganizationId)) {
          this.formCode = newValue.settingInfo.formCode
          this.organizationId = newValue.organizationView.organizationId
          this.getForm()
        }
      }
    },
  },
  created() {
    this.handleSetting()
    /*if (this.isEdit) {
      this.selectedSetting = this.model.settingInfo
      //this.$refs.organizers.search(this.model.organizationTitle)
      this.getOrganizerUsers()
    }*/
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    buttonText: {
      type: String,
      default: 'save',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    SettingItem,
    SettingsSelect,
    OrganizersSelect
  }
}
</script>
<style scoped lang="scss">
.select-items-wrap-search-loading-spinner {
  margin: 0 auto;
}

.smt-form-item-wrap {
  margin-bottom: 15px;
}

.organizer-settings-form-personal {
  margin-bottom: 10px;
}

.organizer-settings-form-personal-title {
  font-weight: bold;
  text-align: center;
  margin: 10px 0;
}
.user-settings {
  &.user-settings.loading {
    background: #c7c7c7;
    height: 40px;
    width: 100%;
    border-radius: 50px;
  }
}
.user-settings-item-user {
  margin-bottom: 0 !important;
  line-height: 1;
  &__label {
    font-size: 14px;
    padding: 0 0 5px;
  }
}
.user-settings-item-action {
  margin: auto 0;
}
.user-settings-item {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 10px;

  &-user {
    flex: 1;
    max-width: calc(40% - 10px);
    &__login,
    &__email {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-size: 15px;
    }
    &__email {
      opacity: 0.8;
    }
  }
  &-setting {
    flex: 1;
    max-width: calc(60% - 10px);
  }

  &-action {
    min-width: 40px;
    max-width: 40px;
  }
}
</style>
